import React from 'react';

export default t => {
  const DebugTranslation = (key, options) => {
    const translated = t(key, options);

    if (typeof translated !== 'string') {
      return translated;
    }

    return (
      <span title={key} style={{ backgroundColor: 'magenta', color: 'white' }}>
        {translated}
      </span>
    );
  };

  return DebugTranslation;
};
